import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addCSVFile, addLineupsToContest, removeLineups } from "../api/entryManager";
import { ContestUploadResponse } from "../types";

export const useFileUpload = () => {
    const queryClient = useQueryClient();
    return useMutation<ContestUploadResponse[], Error>(addCSVFile, {
        onSuccess: () => {
            // Invalidate all contestSummary queries to force refetch
            queryClient.invalidateQueries(['contestSummary']);
            // Also invalidate CSV template as it may have changed
            queryClient.invalidateQueries(['csvTemplate']);
        }
    });
};

export const useAddLineupsToContest = () => {
    const queryClient = useQueryClient();
    return useMutation<ContestUploadResponse[], Error>(addLineupsToContest, {
        onSuccess: () => {
            // Invalidate contestSummary queries to force refetch with updated data
            queryClient.invalidateQueries(['contestSummary']);
            // Also invalidate CSV template as lineup counts have changed
            queryClient.invalidateQueries(['csvTemplate']);
        }
    });
};

export const useRemoveLineupsFromSlate = () => {
    const queryClient = useQueryClient();
    return useMutation(removeLineups, {
        onSuccess: () => {
            // Invalidate contestSummary queries to force refetch with updated data
            queryClient.invalidateQueries(['contestSummary']);
            // Also invalidate CSV template as lineup counts have changed
            queryClient.invalidateQueries(['csvTemplate']);
        }
    });
}